/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Type_HelpInputs */



/**
* | output |
* | --- |
* | "The type of content this group contains" |
*
* @param {Edit_Event_Group_Type_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_type_help = /** @type {((inputs?: Edit_Event_Group_Type_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Type_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le type de contenu que ce groupe contient")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Art der Inhalte, die diese Gruppe enthält")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il tipo di contenuto contenuto in questo gruppo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Тип контента, который содержит эта группа.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El tipo de contenido que contiene este grupo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("此组包含的内容类型")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このグループに含まれるコンテンツの種類")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस समूह में मौजूद सामग्री का प्रकार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O tipo de conteúdo que este grupo contém.")
	return /** @type {LocalizedString} */ ("The type of content this group contains")
});